// Pure helpers for the availability planner (dates are "YYYY-MM-DD" strings, UK local days).
export const DAY_NAMES = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const TIMES = Array.from({ length: 30 }, (_, i) => `${String(7 + Math.floor(i / 2)).padStart(2, "0")}:${i % 2 ? "30" : "00"}`);

const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const parse = (s) => new Date(`${s}T12:00:00`);
export const addDays = (s, n) => { const d = parse(s); d.setDate(d.getDate() + n); return ymd(d); };
export const weekdayIdx = (s) => (parse(s).getDay() + 6) % 7;
export const fmtDay = (s) => parse(s).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });

export const monthGrid = (monthStart) => {
  const first = parse(monthStart);
  const start = addDays(monthStart, -weekdayIdx(monthStart));
  const last = new Date(first.getFullYear(), first.getMonth() + 1, 0);
  const cells = Math.ceil((weekdayIdx(monthStart) + last.getDate()) / 7) * 7;
  return Array.from({ length: cells }, (_, i) => addDays(start, i));
};

export const dayState = (r, day) => {
  if (r.blocked.some((b) => b.from && b.to && b.from <= day && day <= b.to)) return { kind: "closed" };
  const extra = r.open_dates.filter((o) => o.date === day);
  if (extra.length) return { kind: "extra", times: extra.map((o) => `${o.from}–${o.until}`) };
  if (r.usual_hours_until && day <= r.usual_hours_until && !r.no_weekdays.includes(weekdayIdx(day))) {
    if (!r.weekly_hours) return { kind: "usual" };
    const w = r.weekly_hours.filter((x) => x.day === weekdayIdx(day));
    if (w.length) return { kind: "usual", hours: w.map((x) => `${x.from}–${x.until}`) };
  }
  return { kind: "off" };
};

export const rangeDays = (from, to, weekdaysOnly) => {
  const out = [];
  for (let d = from; d <= (to || from); d = addDays(d, 1)) {
    if (!weekdaysOnly || weekdayIdx(d) < 5) out.push(d);
    if (out.length > 400) break;
  }
  return out;
};

// Remove the given days from closed ranges, re-joining what's left into contiguous ranges.
export const subtractDays = (blocked, days) => {
  const drop = new Set(days);
  const out = [];
  blocked.forEach((b) => {
    let cur = null;
    for (let d = b.from; d <= b.to; d = addDays(d, 1)) {
      if (drop.has(d)) { if (cur) out.push(cur); cur = null; continue; }
      cur = cur ? { ...cur, to: d } : { ...b, from: d, to: d, _k: undefined };
    }
    if (cur) out.push(cur);
  });
  return out;
};
